<template>
  <tr>
    <td>
      <template v-if="props.address.bscDlvdesYn === 'Y'">
        <span class="c-round-flag type-primary type-small"> 기본배송지 </span>
        <br />
      </template>
      {{ props.address.dlvdesNm || "-" }}
    </td>
    <td class="ac">{{ props.address.acptrNm }}</td>
    <td>
      <span class="phone"> ({{ props.address.zip }}) </span>
      <span class="address">
        {{ props.address.roadNmBscAddr }} {{ props.address.roadNmDtlAddr }}
      </span>
    </td>
    <td>
      <span class="phone">{{ props.address.acptrWrdTelno }}</span>
      <span class="phone">{{ props.address.acptrMblTelno }}</span>
    </td>
    <td class="ac">
      <div v-if="props.address.bscDlvdesYn === 'N'" class="c-btn-area flex-ac">
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="() => emits('edit', props.address)"
        >
          <span>수정</span>
        </button>
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="() => emits('delete', props.address)"
        >
          <span>삭제</span>
        </button>
      </div>
    </td>
  </tr>
</template>
<script setup>
import { onMounted, defineProps, defineEmits } from "vue";

const props = defineProps({
  address: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits(["edit", "delete"]);

onMounted(() => {});
</script>
